/**
 * Init Mobile Navigation Dropdown
 */
const initMobileNavigationDropdown = () => {
	$navigation = $('.nav');

	$navigation.on('click', '.menu__item--has-dropdown > a', function(event) {
		const $this = $(this);
		const $dropdownParent = $this.closest('li');
		const $dropdownContainer = $dropdownParent.find('> ul');
		const isClickedClass = $dropdownParent.hasClass('is-clicked');

		if (! isClickedClass) {
			$dropdownParent.addClass('is-clicked');

			$dropdownContainer.slideDown();

			$dropdownParent
				.siblings()
				.removeClass('is-clicked')
				.find('ul')
				.slideUp();

			event.preventDefault();
		}
	});
}

initMobileNavigationDropdown();
